export const isContactNameHidden = (value: string) => value === "grid.hidden";
